module.exports = __webpack_public_path__ + "img/4.123b34e9.jpg";